import { lazy } from 'react';
import { Routes, SyncHook } from '../routeTypes';

// Lazy load the Login component
const Login = lazy(() =>
  import('@act/react-components/auth/AuthPages/Login').then(module => ({
    default: module.default,
  }))
);

const useSyncHook: SyncHook = null;

const routes: Routes = [{ path: '/login', element: <Login /> }];

const useNavigationHooks = () => {
  return {};
};

export const loginPageRouteConfig = {
  routes,
  useSyncHook,
  publicRoute: true,
  useNavigationHooks,
};
